import React, {useContext, useEffect, useState} from 'react';
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import {Images} from '../../../common/Assets/Images';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import {DispatchContext} from '../../../store';
import {conservationApi} from '../../../services/ConservationServices';
import {useNavigate} from 'react-router-dom';
import Moment from 'react-moment';

export default function NewConservationTable({status, meta,setMeta}) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [conservations, setConservations] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  useEffect(() => {
    getConservationList();
  },[page, rowsPerPage]);

  const getConservationList = () => {
    conservationApi('get', null, {active_task: true, page: page, per_page: rowsPerPage}).then(res => {
      setConservations(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleDetail = (id) => {
    navigate(`/management/conservators/${id}`);
  }

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{color: '#B3B3B3'}}>Sl.No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Submission Date</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Accession No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Object Name</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Materials</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Condition Assisment</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Classification</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conservations?.length > 0 && conservations?.map((conservation, index) => (
              <TableRow key={index} hover onClick={() => handleDetail(conservation?.id)}>
                <TableCell sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  {index + 1}
                </TableCell>
                <TableCell align="left"><Moment format={'ll'}>{conservation?.created_at}</Moment></TableCell>
                <TableCell align="left">{asText(conservation?.accession_no)}</TableCell>
                <TableCell align="left">{conservation?.catalogue?.object_name || '-'}</TableCell>
                <TableCell align="left">{asText(conservation?.catalogue?.material)}</TableCell>
                <TableCell align="left">{conservation?.condition_assessment|| '-'}</TableCell>
                <TableCell align="left">{asText(conservation?.catalogue?.classification)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}